(function () {
  'use strict';

  if (window.PGOpenAIAdsTrackingV141) return;
  window.PGOpenAIAdsTrackingV141 = true;

  var cfg = window.PGOpenAIAdsV141 || {};
  var pixelId = cfg.pixelId;
  if (!pixelId || typeof window.oaiq !== 'function') return;

  var trackingAllowed = false;
  var initialEventsSent = false;
  var cartCache = null;
  var originalFetch = typeof window.fetch === 'function' ? window.fetch.bind(window) : null;

  function currencyCode() {
    if (cartCache && cartCache.currency) return cartCache.currency;
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    return cfg.currency || 'GBP';
  }

  function eventId(prefix, suffix) {
    return [prefix, suffix || '', Date.now(), Math.random().toString(36).slice(2, 9)]
      .filter(Boolean)
      .join('_');
  }

  function safeMeasure(name, data, options) {
    if (!trackingAllowed || typeof window.oaiq !== 'function') return;
    try {
      window.oaiq('measure', name, data || { type: 'contents' }, options || undefined);
    } catch (err) {
      if (cfg.debug && window.console) console.warn('[PG OpenAI Ads] measure failed', name, err);
    }
  }

  function productContent() {
    var product = cfg.product;
    if (!product || !product.id) return null;
    return {
      id: String(product.id),
      name: product.name || document.title,
      content_type: 'product',
      quantity: 1,
      amount: Number(product.amount || 0),
      currency: currencyCode()
    };
  }

  function sendInitialEvents() {
    if (!trackingAllowed || initialEventsSent) return;
    initialEventsSent = true;

    safeMeasure('page_viewed', {
      type: 'contents',
      contents: [{
        id: window.location.pathname || '/',
        name: document.title || 'Paw & Glory',
        content_type: 'page'
      }]
    });

    var product = productContent();
    if (product) {
      safeMeasure('contents_viewed', {
        type: 'contents',
        amount: product.amount,
        currency: product.currency,
        contents: [product]
      });
    }
  }

  function applyConsent(allowed) {
    trackingAllowed = !!allowed;
    try {
      window.oaiq('consent', trackingAllowed);
    } catch (err) {
      if (cfg.debug && window.console) console.warn('[PG OpenAI Ads] consent sync failed', err);
    }
    if (trackingAllowed) sendInitialEvents();
  }

  function syncShopifyConsent(fallbackIfUnavailable) {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (privacy && typeof privacy.analyticsProcessingAllowed === 'function' && typeof privacy.marketingAllowed === 'function') {
      try {
        applyConsent(privacy.analyticsProcessingAllowed() && privacy.marketingAllowed());
        return true;
      } catch (err) {
        if (cfg.debug && window.console) console.warn('[PG OpenAI Ads] privacy API check failed', err);
      }
    }
    if (fallbackIfUnavailable) applyConsent(false);
    return false;
  }

  function itemToContent(item) {
    if (!item) return null;
    var quantity = Number(item.quantity || 1);
    var unitAmount = Number(
      item.final_price != null ? item.final_price :
      item.discounted_price != null ? item.discounted_price :
      item.price != null ? item.price : 0
    );
    return {
      id: String(item.variant_id || item.id || item.sku || ''),
      name: item.product_title || item.title || item.name || 'Product',
      content_type: 'product',
      quantity: quantity,
      amount: unitAmount,
      currency: currencyCode()
    };
  }

  function handleCartAdd(payload) {
    if (!payload) return;
    var rawItems = Array.isArray(payload.items) ? payload.items : [payload];
    var contents = [];
    var amount = 0;

    rawItems.forEach(function (item) {
      var content = itemToContent(item);
      if (!content || !content.id) return;
      contents.push(content);
      var lineAmount = Number(
        item.final_line_price != null ? item.final_line_price :
        item.line_price != null ? item.line_price : content.amount * content.quantity
      );
      amount += lineAmount;
    });

    if (!contents.length) return;
    safeMeasure('items_added', {
      type: 'contents',
      amount: Math.round(amount),
      currency: currencyCode(),
      contents: contents
    }, {
      event_id: eventId('items_added', contents[0].id)
    });

    window.setTimeout(refreshCart, 150);
  }

  function refreshCart() {
    if (!originalFetch) return Promise.resolve(cartCache);
    return originalFetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .then(function (cart) {
        if (cart) cartCache = cart;
        return cartCache;
      })
      .catch(function () { return cartCache; });
  }

  function cartContents(cart) {
    if (!cart || !Array.isArray(cart.items)) return [];
    return cart.items.map(itemToContent).filter(Boolean);
  }

  function sendCheckoutStarted() {
    var cart = cartCache;
    var data = { type: 'contents' };
    var suffix = 'cart';

    if (cart) {
      data.amount = Math.round(Number(cart.total_price || 0));
      data.currency = cart.currency || currencyCode();
      data.contents = cartContents(cart);
      suffix = cart.token || suffix;
    }

    safeMeasure('checkout_started', data, {
      event_id: 'checkout_' + String(suffix)
    });
  }

  function isCartAddUrl(url) {
    return /\/cart\/add(?:\.js)?(?:\?|$)/i.test(String(url || ''));
  }

  if (originalFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var promise = originalFetch(input, init);
      if (isCartAddUrl(url)) {
        promise.then(function (response) {
          if (!response || !response.ok) return;
          response.clone().json().then(handleCartAdd).catch(function () {});
        }).catch(function () {});
      }
      return promise;
    };
  }

  if (window.XMLHttpRequest && window.XMLHttpRequest.prototype) {
    var originalOpen = window.XMLHttpRequest.prototype.open;
    var originalSend = window.XMLHttpRequest.prototype.send;

    window.XMLHttpRequest.prototype.open = function (method, url) {
      this.__pgOaiCartAdd = isCartAddUrl(url);
      return originalOpen.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.send = function () {
      if (this.__pgOaiCartAdd) {
        this.addEventListener('load', function () {
          if (this.status < 200 || this.status >= 300) return;
          try { handleCartAdd(JSON.parse(this.responseText || '{}')); } catch (err) {}
        });
      }
      return originalSend.apply(this, arguments);
    };
  }

  function closestCheckoutControl(node) {
    while (node && node !== document) {
      if (node.matches && node.matches('a[href*="/checkout"],button[name="checkout"],input[name="checkout"],[data-checkout]')) return node;
      node = node.parentNode;
    }
    return null;
  }

  document.addEventListener('click', function (event) {
    if (closestCheckoutControl(event.target)) sendCheckoutStarted();
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches) return;
    if (form.matches('form[action*="/cart"]') && form.querySelector('[name="checkout"]')) {
      sendCheckoutStarted();
    }
  }, true);

  document.addEventListener('visitorConsentCollected', function () {
    syncShopifyConsent(false);
  });

  function boot() {
    refreshCart();

    if (syncShopifyConsent(false)) return;
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (syncShopifyConsent(false) || tries >= 12) {
        window.clearInterval(timer);
        if (tries >= 12) syncShopifyConsent(true);
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();